import type { Dir } from './constants';

const KEY_DIRS: Record<string, Dir> = {
  ArrowUp: 'up',
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  KeyW: 'up',
  KeyS: 'down',
  KeyA: 'left',
  KeyD: 'right',
};

export function dirFromKey(code: string): Dir | null {
  return KEY_DIRS[code] ?? null;
}

export function dirFromSwipe(dx: number, dy: number, threshold = 24): Dir | null {
  if (Math.abs(dx) < threshold && Math.abs(dy) < threshold) return null;
  if (Math.abs(dx) > Math.abs(dy)) return dx > 0 ? 'right' : 'left';
  return dy > 0 ? 'down' : 'up';
}

export function bindInput(
  target: HTMLElement,
  onDir: (dir: Dir) => void,
  onAction: () => void,
): () => void {
  const onKey = (e: KeyboardEvent) => {
    if (e.code === 'Space' || e.code === 'Enter') {
      e.preventDefault();
      onAction();
      return;
    }
    const dir = dirFromKey(e.code);
    if (!dir) return;
    e.preventDefault();
    onDir(dir);
  };

  let touchX = 0;
  let touchY = 0;
  let touching = false;

  const onTouchStart = (e: TouchEvent) => {
    const t = e.changedTouches[0];
    if (!t) return;
    touching = true;
    touchX = t.clientX;
    touchY = t.clientY;
  };

  const onTouchMove = (e: TouchEvent) => {
    if (touching) e.preventDefault();
  };

  const onTouchEnd = (e: TouchEvent) => {
    if (!touching) return;
    touching = false;
    const t = e.changedTouches[0];
    if (!t) return;
    const dir = dirFromSwipe(t.clientX - touchX, t.clientY - touchY);
    if (dir) onDir(dir);
    else onAction();
  };

  window.addEventListener('keydown', onKey);
  target.addEventListener('touchstart', onTouchStart, { passive: true });
  target.addEventListener('touchmove', onTouchMove, { passive: false });
  target.addEventListener('touchend', onTouchEnd);

  return () => {
    window.removeEventListener('keydown', onKey);
    target.removeEventListener('touchstart', onTouchStart);
    target.removeEventListener('touchmove', onTouchMove);
    target.removeEventListener('touchend', onTouchEnd);
  };
}
